import { Controller } from "@hotwired/stimulus"

// Matches work_times HH:MM pattern (24-hour).
const TIME_RE = /^(0?[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/

export default class extends Controller {
  static targets = ["daySelect", "startTime", "endTime", "submitBtn"]

  connect() {
    this.update()
  }

  update() {
    const dayOk = this.daySelectTarget.value !== ""
    const startOk = TIME_RE.test(this.startTimeTarget.value.trim())
    const endOk = TIME_RE.test(this.endTimeTarget.value.trim())
    this.submitBtnTarget.disabled = !(dayOk && startOk && endOk)
  }
}
